import styled from 'styled-components';
export const MicrosoftSignInAnchor = styled.a.withConfig({
  displayName: "MicrosoftLoginButtonstyles__MicrosoftSignInAnchor",
  componentId: "sc-1gfy56t-0"
})(["align-items:center;background-color:#2f2f2f;border-radius:0.1875rem;color:white;cursor:pointer;display:flex;font-family:'Segoe',sans-serif;font-weight:600;gap:12px;height:41px;justify-content:center;min-width:max-content;padding:0 12px;position:relative;text-align:center;width:100%;&:hover{background-color:#4d4d4d;color:white;text-decoration:none;}"]);
export const ButtonText = styled.span.withConfig({
  displayName: "MicrosoftLoginButtonstyles__ButtonText",
  componentId: "sc-1gfy56t-1"
})(["flex-grow:1;padding-right:", ";"], props => props.smartLogin ? '21px' : '12px');